import HomeGamepad from "../Home/Gamepad"

const Scenario = {
    "home": {
        // screen : Home.screen,
        gamepad: <HomeGamepad />
    }
}

export default Scenario;